import { useEffect } from 'react';
import { useMap } from '@vis.gl/react-google-maps';
import { MapViewOptions } from '../../../utils/helpers/map';

interface MapOptionsSyncProps {
  options: MapViewOptions;
}

export const MapOptionsSync = ({ options }: MapOptionsSyncProps) => {
  const map = useMap();

  useEffect(() => {
    map?.setOptions(options);
  }, [map, options]);

  return null;
};
